// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rEvn","toggle":"styles_toggle__38kaQ","preview":"styles_preview__w1CgO"};